module.exports = __webpack_public_path__ + "static/img/Planificaciones_4_en segundos@4x.937917d7.png";